import { type PropsWithChildren } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_API_KEY, {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2025-05-24',
});
export const AnalyticsProvider = ({ children }: PropsWithChildren) => {
  if (import.meta.env.VITE_PUBLIC_APP_ENV === 'staging') {
    return <>{children}</>;
  }

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
};
